var _g, _path, _path2, _path3, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomersHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 120,
    viewBox: "0 0 110 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_472_9900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4975 107.957C50.4722 109.095 52.712 109.693 54.9921 109.693C57.2723 109.693 59.5122 109.095 61.4869 107.957L93.5054 89.5239C95.4799 88.3868 97.1195 86.7514 98.2596 84.782C99.3996 82.8125 99.9998 80.5784 100 78.3042L100 41.3902C99.9998 39.116 99.3996 36.8819 98.2596 34.9125C97.1195 32.943 95.4799 31.3076 93.5054 30.1705L61.4868 11.7369C59.5122 10.5998 57.2723 10.0011 54.9921 10.0011C52.712 10.0011 50.4722 10.5998 48.4975 11.7369L16.4947 30.1705C14.5202 31.3076 12.8806 32.943 11.7405 34.9125C10.6005 36.8819 10.0002 39.116 9.99999 41.3902L10 78.3042C10.0002 80.5784 10.6005 82.8125 11.7405 84.782C12.8806 86.7514 14.5202 88.3869 16.4947 89.524L48.4975 107.957Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.2346 82.6236C41.421 78.9366 40.0765 75.2329 39.201 71.5127C38.3255 67.7592 37.8878 63.9227 37.8878 60.0031C37.8878 56.0836 38.3255 52.2637 39.201 48.5434C40.0765 44.8232 41.421 41.1029 43.2346 37.3826L45.4389 38.2297C42.4372 45.4709 40.9364 52.7287 40.9364 60.0031C40.9364 67.2776 42.4372 74.5354 45.4389 81.7766L43.2346 82.6236Z",
    fill: "url(#paint0_linear_472_9900)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3012 85.002L41.5401 83.4546C39.6686 79.6495 38.2737 75.8122 37.3633 71.9438L37.3624 71.9402C36.4537 68.0442 36 64.0641 36 60.0031C36 55.9421 36.4537 51.9773 37.3633 48.1121C38.2733 44.2451 39.6674 40.3932 41.5372 36.5576L42.2955 35.002L47.9235 37.1645L47.1832 38.9505C44.2688 45.981 42.8242 52.9946 42.8242 60.0031C42.8242 67.0115 44.2688 74.0251 47.1832 81.0556L47.9235 82.8416L42.3012 85.002ZM43.2346 82.6236C41.421 78.9366 40.0765 75.2329 39.201 71.5127C38.3255 67.7592 37.8878 63.9227 37.8878 60.0031C37.8878 56.0836 38.3255 52.2637 39.201 48.5434C40.0765 44.8232 41.421 41.1029 43.2346 37.3826L45.4389 38.2297C45.1969 38.8136 44.9646 39.3975 44.7421 39.9816C42.2049 46.6414 40.9364 53.3153 40.9364 60.0031C40.9364 66.691 42.2049 73.3647 44.7421 80.0245C44.9646 80.6086 45.1969 81.1927 45.4389 81.7766L43.2346 82.6236Z",
    fill: "url(#paint1_linear_472_9900)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0553 51.839L59.0552 49.5045C59.0548 49.4427 59.0667 49.3815 59.0903 49.3245C59.1139 49.2674 59.1488 49.2157 59.1927 49.1722C59.2367 49.1288 59.2891 49.0945 59.3466 49.0714C59.4041 49.0484 59.4656 49.037 59.5277 49.0379L60.7882 49.0374C60.9167 48.5933 61.0949 48.1651 61.3195 47.7608L60.4267 46.8688C60.3404 46.7801 60.2925 46.6613 60.2931 46.538C60.2938 46.4147 60.3429 46.2967 60.4301 46.2092L62.0882 44.5585C62.1326 44.5152 62.1851 44.481 62.2428 44.4578C62.3004 44.4347 62.3622 44.4232 62.4244 44.4238C62.4866 44.4244 62.5481 44.4372 62.6054 44.4614C62.6626 44.4857 62.7146 44.5209 62.7582 44.5651L63.6459 45.4482C64.0543 45.2257 64.4864 45.0493 64.9343 44.9222L64.9383 43.6697C64.9376 43.6084 64.9491 43.5475 64.9722 43.4907C64.9952 43.4339 65.0294 43.3823 65.0727 43.3387C65.1159 43.2951 65.1674 43.2605 65.2243 43.2369C65.2811 43.2133 65.3421 43.2012 65.4037 43.2012L67.7568 43.2077C67.8181 43.2083 67.8787 43.2209 67.9352 43.2448C67.9916 43.2687 68.0428 43.3035 68.0858 43.347C68.1287 43.3906 68.1627 43.4422 68.1857 43.4988C68.2086 43.5553 68.2202 43.6159 68.2197 43.6769L68.2227 44.9313C68.67 45.0592 69.1004 45.2399 69.5048 45.4695L70.3994 44.5828C70.4875 44.4957 70.6067 44.4466 70.7311 44.4462C70.8555 44.4458 70.9751 44.494 71.0642 44.5806L72.7245 46.2409C72.7681 46.2843 72.8026 46.3359 72.8261 46.3927C72.8495 46.4495 72.8614 46.5103 72.8611 46.5717C72.8607 46.633 72.8483 46.6937 72.8242 46.7501C72.8002 46.8065 72.7652 46.8577 72.7211 46.9005L71.8336 47.789C72.0605 48.1924 72.2395 48.6207 72.3667 49.0651L73.6254 49.0716C73.7502 49.0729 73.8695 49.1231 73.9574 49.2112C74.0454 49.2994 74.095 49.4185 74.0953 49.5427L74.0953 51.8772C74.0943 52.0013 74.0441 52.1199 73.9557 52.2073C73.8673 52.2946 73.7477 52.3437 73.6229 52.3438L72.3642 52.3373C72.2351 52.7837 72.0563 53.2142 71.831 53.6209L72.7168 54.5109C72.7612 54.554 72.7965 54.6054 72.8207 54.6621C72.8449 54.7188 72.8575 54.7797 72.8579 54.8412C72.8582 54.9028 72.8462 54.9638 72.8226 55.0207C72.799 55.0775 72.7644 55.1291 72.7205 55.1725L71.0572 56.8142C71.014 56.8583 70.9625 56.8933 70.9056 56.9173C70.8486 56.9412 70.7874 56.9537 70.7256 56.9539C70.6637 56.9541 70.6024 56.9421 70.5452 56.9185C70.488 56.8949 70.4361 56.8603 70.3924 56.8165L69.4996 55.9246C69.0946 56.1496 68.6646 56.3267 68.2182 56.4525L68.2142 57.705C68.2149 57.7663 68.2034 57.8271 68.1803 57.8839C68.1573 57.9407 68.1231 57.9924 68.0798 58.036C68.0366 58.0795 67.9851 58.1141 67.9282 58.1377C67.8714 58.1613 67.8105 58.1735 67.7488 58.1735L65.3957 58.1669C65.271 58.1657 65.1516 58.1155 65.0636 58.0273C64.9756 57.9391 64.9261 57.82 64.9258 57.6959L64.9297 56.4434C64.4796 56.3177 64.0462 56.1388 63.6388 55.9103L62.7512 56.7988C62.7076 56.8421 62.6558 56.8763 62.5988 56.8995C62.5418 56.9227 62.4807 56.9345 62.419 56.934C62.3574 56.9336 62.2964 56.921 62.2396 56.897C62.1829 56.8729 62.1315 56.838 62.0883 56.7941L60.4261 55.1408C60.3818 55.0977 60.3465 55.0464 60.3223 54.9897C60.298 54.933 60.2854 54.8721 60.285 54.8105C60.2847 54.7489 60.2967 54.6879 60.3203 54.6311C60.3439 54.5742 60.3786 54.5226 60.4225 54.4793L61.317 53.5926C61.0907 53.1867 60.9124 52.7561 60.7858 52.3095L59.5252 52.31C59.4005 52.3088 59.2811 52.2586 59.1931 52.1704C59.1051 52.0822 59.0556 51.9631 59.0553 51.839ZM64.833 49.5249C64.6064 49.8679 64.4874 50.2703 64.491 50.6811C64.4958 51.2288 64.7181 51.7528 65.1095 52.1388C65.5008 52.5248 66.0294 52.7414 66.5799 52.7413C66.9928 52.7413 67.396 52.6192 67.7386 52.3906C68.0812 52.1621 68.3477 51.8373 68.5043 51.4574C68.6608 51.0776 68.7005 50.6598 68.618 50.2571C68.5356 49.8543 68.3349 49.4848 68.0413 49.1953C67.7478 48.9058 67.3746 48.7093 66.9692 48.6309C66.5637 48.5525 66.1443 48.5956 65.764 48.7548C65.3837 48.9139 65.0597 49.182 64.833 49.5249ZM54.2435 57.3874C54.2435 57.1113 54.0196 56.8874 53.7435 56.8874L36.5615 56.8874C36.2853 56.8874 36.0615 57.1113 36.0615 57.3874L36.0615 62.7953C36.0615 63.0714 36.2853 63.2953 36.5615 63.2953L53.7435 63.2953C54.0196 63.2953 54.2435 63.0714 54.2435 62.7953V57.3874ZM65.2275 66.0395C65.94 65.6302 66.8162 65.6302 67.5287 66.0395L71.1347 68.1116C71.8516 68.5235 72.2935 69.2872 72.2935 70.1139V74.239C72.2935 75.0657 71.8516 75.8294 71.1347 76.2413L67.5287 78.3134C66.8162 78.7227 65.94 78.7227 65.2275 78.3134L61.6215 76.2413C60.9046 75.8294 60.4627 75.0657 60.4627 74.239V70.1139C60.4627 69.2872 60.9046 68.5235 61.6215 68.1116L65.2275 66.0395Z",
    fill: "url(#paint2_linear_472_9900)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_472_9900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4975 107.956C50.4722 109.093 52.712 109.691 54.9921 109.691C57.2723 109.691 59.5122 109.093 61.4869 107.956L93.5054 89.522C95.4799 88.3849 97.1195 86.7495 98.2596 84.78C99.3996 82.8105 99.9998 80.5765 100 78.3023L100 41.3883C99.9998 39.1141 99.3996 36.88 98.2596 34.9105C97.1195 32.9411 95.4799 31.3056 93.5054 30.1685L61.4868 11.735C59.5122 10.5978 57.2723 9.99911 54.9921 9.99911C52.712 9.99911 50.4722 10.5978 48.4975 11.735L16.4947 30.1685C14.5202 31.3056 12.8806 32.9411 11.7405 34.9105C10.6005 36.88 10.0002 39.1141 9.99999 41.3883L10 78.3023C10.0002 80.5765 10.6005 82.8106 11.7405 84.78C12.8806 86.7495 14.5202 88.3849 16.4947 89.522L48.4975 107.956Z",
    fill: "#2468FF",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_472_9900",
    x: 0,
    y: 0.00195312,
    width: 110,
    height: 119.691,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.768627 0 0 0 0 0.768627 0 0 0 0 0.768627 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_472_9900"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_472_9900",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_472_9900",
    x: 0,
    y: 0,
    width: 110,
    height: 119.691,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.768627 0 0 0 0 0.768627 0 0 0 0 0.768627 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_472_9900"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_472_9900",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_472_9900",
    x1: 45.7993,
    y1: 35.3464,
    x2: 17.7901,
    y2: 67.2977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F8EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#927FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_472_9900",
    x1: 45.7993,
    y1: 35.3464,
    x2: 17.7901,
    y2: 67.2977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F8EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#927FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_472_9900",
    x1: 32.3418,
    y1: 74.0078,
    x2: 111.63,
    y2: 44.2489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010305",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersHover);
export default __webpack_public_path__ + "static/media/customers_hover.21279b4e109ed7cca5a7a97df9128fdf.svg";
export { ForwardRef as ReactComponent };